import { useState, useEffect } from 'react'
import { adminAgentsAPI } from '../../../services/api'

export function useAgentList(refreshKey = 0) {
  const [agents, setAgents] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(null)
    adminAgentsAPI.listAgents()
      .then(list => { if (!cancelled) setAgents(list || []) })
      .catch(err => { if (!cancelled) setError(err.message || 'Failed to load agents') })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [refreshKey])

  return { agents, loading, error }
}
